/**
 * @module recurringFrequency
 * @description A list of recurringFrequency
 */

export const recurringFrequency = [
	'weekly',
	'fortnightly',
	'monthly',
	'quarterly',
	'biannually',
	'annually',
] as const;
export type RecurringFrequency = (typeof recurringFrequency)[number];
